import { MetadatoDocumento, MetadatoFirmaDocumenti } from '../form/documento/document-uploaded/campi';
import { SignedData } from './signed-data';
import { Provenienza } from './tipologiche/provenienza';
import { TipoDocumento } from './tipologiche/tipo-documento';
import { TipoTipologica } from './tipologiche/tipo-tipologica';
import {VisibilitaDocumento} from './tipologiche/visibilita-documento';

export class DocumentoAllegato {
  refDocumentale: string;
  autore: string;
  contentType: string;
  contentSize:number;
  dataAggiornamento: number;
  dataCaricamento: number;
  dataCreazione: number;
  dataRiferimento: number;
  dataProtocollazione: number;
  id: string;
  nomeFile: string;
  primary?: boolean;
  note: string;
  posizione: string;
  provenienza: Provenienza;
  archivio: TipoTipologica;
  tipoDocumento: TipoDocumento;
  tipoVisibilitaDocumento: VisibilitaDocumento;
  titolo: string;
  utenteAggiornamento: string;
  utenteCreazione: string;
  versione: string;
  entitaCollegata: any;
  numeroProtocollo: string;
  flagOcr: boolean;
  utenteProtocollatore?: string;
  flagTimbratura?:boolean;
  flagAllegatoPrincipale?:boolean;
  oggettoProtocollo: string;
  oggettoProtocolloEsteso: string;
  inUscita: boolean;
  senderReceiver?:string
  protocolDocuments: any[];
  missingFile: boolean;
  flagAttoPrincipale?:boolean;
  statoDocumento?:string;
  estremiProvvedimento?:string;
  dataAnnullamento?:number;
  identificativoOperatore?:string; 
  metadatoDocumento?: MetadatoDocumento;
  metadatoFirmaDocumenti?: MetadatoFirmaDocumenti[];
  signedData?: SignedData;
  algoritmoImprontaDocumento?:string;
  improntaDocumento?:string;
  classeTitolario?:string;
  statoConservazione?:string;

  constructor(provenienzaAtto?, tipoAtto?){
    if(provenienzaAtto && tipoAtto){
      this.provenienza = provenienzaAtto;
      this.tipoDocumento = tipoAtto;
    }
  }
}

export class DocumentoAllegatoRequest {
  constructor(documenti: DocumentoAllegato[]) {
    this.documenti = documenti;
  }

  documenti: DocumentoAllegato[];
}
